const gallery = [ // galley image list
  require('./Image/1.jpg'),
  require('./Image/2.jpg'),
  require('./Image/3.jpg'),
  require('./Image/4.jpg'),
  require('./Image/5.jpg'),
  require('./Image/6.jpg'),
  require('./Image/7.jpg'),
  require('./Image/8.jpg'),    
  require('./Image/9.jpg'),    
  require('./Image/10.jpg'),
  require('./Image/11.jpg'),
  require('./Image/12.jpg'),
  require('./Image/13.jpg'),
  require('./Image/14.jpg'),
  require('./Image/15.jpg'),
  require('./Image/16.jpg'),
  require('./Image/17.jpg'),
  require('./Image/18.jpg'),
  require('./Image/19.jpg'),
  require('./Image/20.jpg'),
  require('./Image/21.jpg'),
  require('./Image/22.jpg'),
  require('./Image/23.jpg'),
  require('./Image/24.jpg'),
  require('./Image/25.jpg'),
  require('./Image/26.jpg'),
  require('./Image/27.jpg'),
  require('./Image/28.jpg'),
  require('./Image/29.jpg'),
  require('./Image/30.jpg'),
  require('./Image/31.jpg'),
  require('./Image/32.jpg'),
  require('./Image/33.jpg'),
  require('./Image/34.jpg'),
  require('./Image/35.jpg'),
  require('./Image/36.jpg'),
  require('./Image/37.jpg'),
  require('./Image/38.png')
];


const config = {
  title: 'Wedding Invitation', // recomanded English
  wedding: {
    place: {
      name: '마리아쥬스퀘어',
      address: '서울특별시 강남구 도산대로 318 SB타워 G층 마리아쥬스퀘어',
      latitude: 37.51990006878117,
      longitude: 126.94020220536675,
    },
    at: '2022-10-03 11:00',
    image: require('./Image/map.png'),
    message: require('./Image/message.png'),
    information: require('./Image/information.png')
  },
  bridal: {
    name: '이규영',
    image: require('./Image/gyu.jpg'),
    phone: '+821056950311',
    facebook: false,
    father: '이경선',
    mother: '김옥이',
    position: '딸',
    role:'신부'
  },
  groom: {
    name: '이규범',
    image: require('./Image/kyu.jpg'),
    phone: '+821043127323',
    facebook: false, // if false, not showing facebook icon
    father: '이계용',
    mother: '배경란',
    position: '아들',
    role:'신랑'
  },
  phonebook: {
    groom:         '+821043127323',
    groom_father:  '+821037909523',
    groom_mother:  '+821062039523',
    bridal:        '+821056950311',
    bridal_father: '+821024714472',
    bridal_mother: '+821084724472',
  },
  accountNumber: {
    groom:         '우리 1002-358-735464 (예금주: 이규범)',
    groom_father:  '농협 131-02-233586 (예금주: 이계용)',
    groom_mother:  '농협 134-02-187808 (예금주: 배경란)',
    bridal:        '신한 110-501-593191 (예금주: 이규영)',
    bridal_father: '국민 043-01-0467-146 (예금주: 이경선)',
    bridal_mother: '신한 110-501-593191 (예금주: 이규영)',
  },
  image: {
    header: require('./Image/page001.png'),
    gallery: gallery.map(item => ({
      original: item,
      thumbnail: item,
      originalHeight: 400,
      originalWidth: 400,
      thumbnailHeight: 100,
      thumbnailWidth: 100
    })),
  },
};

export default config;